import { z } from 'zod';

export const UI_EFFECT_DATA_PART = 'ui-effect' as const;
export const UI_EFFECT_PART_TYPE = `data-${UI_EFFECT_DATA_PART}` as const;

export enum RachelResource {
  CATALOG = 'catalog',
  ORDER = 'order',
  STORE_ORDER = 'store-order',
  TARGET = 'target',
}

export const RACHEL_LIST_SCOPE = 'list';

const NonEmptyStringSchema = z.string().min(1);
const INTERNAL_PATH_PATTERN = /^\/(?!\/)(?!.*[\\\u0000-\u001F\u007F])/;
const hasProtocol = (to: string) => /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(to);
const isInternalPath = (to: string) => INTERNAL_PATH_PATTERN.test(to) && !hasProtocol(to);

export const ChangedEffectSchema = z.object({
  kind: z.literal('changed'),
  resource: NonEmptyStringSchema,
  scopeId: NonEmptyStringSchema,
  ids: z.array(NonEmptyStringSchema).optional(),
});

export const NavigateEffectSchema = z.object({
  kind: z.literal('navigate'),
  to: NonEmptyStringSchema.refine(isInternalPath),
});

export const UiEffectSchema = z.discriminatedUnion('kind', [
  ChangedEffectSchema,
  NavigateEffectSchema,
]);

export type UiEffect = z.infer<typeof UiEffectSchema>;
export type ChangedEffect = z.infer<typeof ChangedEffectSchema>;
